import { createFileRoute, redirect } from '@tanstack/react-router';
import { fetchMe, fetchMeMemberships } from '@/features/account/queries/me';
import { authService } from '@/lib/auth/ory/service';
export const Route = createFileRoute('/me/')({
  beforeLoad: async () => {
    const status = await authService.getAuthenticationStatus();
    if (status === 'unauthenticated' || status === 'requires_mfa') {
      throw redirect({
        to: '/auth/sign-in',
        replace: true
      });
    }
  },
  loader: async () => {
    const [me, memberships] = await Promise.all([fetchMe(), fetchMeMemberships()]);
    return {
      me,
      memberships
    };
  }
});